import { User } from "interfaces/auth";

export const getCurrentCompany = (user?: User) => user?.companies.find((company) => company.id === user.currentCompanyId);
